import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { getAllOrganizations } from "../../../redux/actions/Organizations"
import { SearchBarAndFiltersOrganization } from "../SearchAndFilters/SearchBarAndFilterOrganization"
import TableHeader from "./TableHeader/TableHeader"
import TableItem from "./TableItem/TableItem"

import useStyles from "./useStyles"

function OrganizationTable({
  rows,
  setRows,
  setLoading,
  openFilterByType,
  setopenFilterByType,
  valueFilter,
  setvalueFilter,
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const organization = useSelector((state) => state.organization)

  function getOrgsNoDuplicate(newarr) {
    return newarr.filter((item, index) => {
      const ifExists = (element) =>
        element.organizationId === item.organizationId
      return newarr.findIndex(ifExists) === index
    })
  }

  // get organizations
  const handleGetOrganizations = async () => {
    const params = organization.searchValueCUIT
      ? { organizationCuit: organization.searchValueCUIT }
      : undefined

    if (organization.searchValueName) {
      let candidates = []
      const paramsName = {
        organizationName: organization.searchValueName.toUpperCase(),
      }
      candidates = candidates.concat(
        await dispatch(getAllOrganizations(paramsName)),
      )
      const paramsLegalName = {
        organizationLegalName: organization.searchValueName.toUpperCase(),
      }
      candidates = candidates.concat(
        await dispatch(getAllOrganizations(paramsLegalName)),
      )

      const orgs = getOrgsNoDuplicate(candidates)
      setRows(orgs)
      return
    }
    const response = await dispatch(getAllOrganizations(params))
    setRows(response)
  }

  useEffect(async () => {
    setLoading(true)

    await handleGetOrganizations()
    setLoading(false)
  }, [])

  return (
    <>
      <div className={classes.root}>
        <SearchBarAndFiltersOrganization
          rows={rows}
          setRows={setRows}
          setLoading={setLoading}
          openFilterByType={openFilterByType}
          setopenFilterByType={setopenFilterByType}
          valueFilter={valueFilter}
          setvalueFilter={setvalueFilter}
        />

        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <TableHeader />

            <tbody className={classes.tableBody}>
              {rows.map((item, index) => (
                <TableItem
                  listIndex={index}
                  key={item.organizationId}
                  item={item}
                  setLoading={setLoading}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default OrganizationTable
